import { Button, Divider, Form, Input, Modal, Select, Upload, DatePicker } from "antd";
import { useState, useRef, useEffect } from "react";
import * as Validation from "../../../../utils/helper/validation";
import * as Apis from "../../../../utils/helper/enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";

import config from "../../../../config";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
const vendor_Type = [
  {
    value: "host",
    label: "Host",
  },
  {
    value: "host_seller",
    label: "Host & Seller",
  },
  {
    value: "seller",
    label: "Seller",
  },
];
const VendorPersonalDetails = ({setWalletToggle}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);

  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [list, setList] = useState([]);

  const [allCategories,setAllCategories] = useState([]); //allCategories
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  // const [dropzones,setDropzones] = useState([]);//dropzones
  // const [showAssociateDropZone, setShowAssociateDropZone] = useState(false);

  let { id } = useParams();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleUpload = ({ file }) => {
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > maxSize) {
      // Show an error message or notification
      toast.error("File size must be less than 5 MB.");
      return false; // Prevent adding the file to the file list
    }

    if (file.status === "removed") return false;

    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setPreviewOpen(true);
    return false; // Prevent automatic upload
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 500, // Reduce width (Adjust as needed)
        height: 500, // Reduce height
      });
      const croppedImage = canvas.toDataURL("image/jpeg", 0.7); // Lower quality to 70%
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: croppedImage,
        },
      ]);
      setPreviewOpen(false);
      setPreviewImage(croppedImage);
    }
  };

  const handleRemove = (file) => {
    setFileList([]);
    setPreviewImage("");
    setPreviewOpen(false);
  };

  // const handleChange = ({ fileList }) => {
  //   setFileList(fileList);
  //   handleInputChange("business_image");
  // };

  // const handlePreview = async (file) => {
  //   setPreviewImage(file.url || file.thumbUrl);
  //   setPreviewOpen(true);
  // };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <img src={previewImage ? previewImage : config.IMAGEBASEURL + `images/upload-img.png`} alt="Upload" />
    </button>
  );

    const getAllBusinessCategories = async () => {
      try {
        let response = await globalRequest(
          Apis.MANAGE_VENDOR.GET_ALL_BUSINESS_CATEGORIES,
          "get",
          {},
          {},
          true
        );
        let apiResponse = response?.data;
        if (response?.status === 200) {
          let data = apiResponse?.data?.map((item) => {
            return {
              value: item?.id,
              label: item?.locales?.[0]?.name || "No Name",
            };
          });
          setAllCategories(data);
          return data;
        } else {
          toast.error(apiResponse?.message);
          return []; 
        }
      } catch (e) {
        toast.error(e?.message);
        return [];
      }
    };

  // const getAllDropzones = async () => {
  //   try {
  //     let response = await globalRequest(
  //       Apis.MANAGE_VENDOR.GET_ALL_DropZones,
  //       "get",
  //       {},
  //       {},
  //       true
  //     );
  //     let apiResponse = response?.data;
  //     if (response?.status === 200) {
  //       let data = apiResponse?.data?.map((item) => {
  //         return {
  //           value: item?.id,
  //           label: item?.dropZoneLocales?.[0]?.name + ` (${item?.address})`,
  //         };
  //       });
  //       setDropzones(data);
  //     } else {
  //       toast.error(apiResponse?.message);
  //     }
  //   } catch (e) {
  //     toast.error(e?.message);
  //   }
  // };

  const handleSubmit = async (values) => {
    if (previewImage === "") {
      form.setFields([
        {
          name: "business_image",
          errors: ["Please select your Profile picture."],
        },
      ]);
      return false;
    }

    if (values.total_no_of_branches === 0) {
      form.setFields([
        {
          name: "total_no_of_branches",
          errors: ["Enter the Total number of branches."],
        },
      ]);
      return false;
    }

    values.business_image = previewImage;
    const selectedSubscription = list?.find((item) => item.id === values.subscription_id);
      if (selectedSubscription) {
        const subStart = new Date(selectedSubscription.startDate);
        const subEnd = new Date(selectedSubscription.endDate);
        const formStart = new Date(values.startDate);
        const formEnd = new Date(values.endDate);

        if (formStart < subStart || formEnd > subEnd) {
          toast.error("Selected dates must be within the subscription's valid date range.");
          return;
        }
      }
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_VENDOR?.CREATE_VENDER;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_VENDOR?.EDIT_VENDER + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Vendor created successfully";
        if (id) msg = "Vendor updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-vendor");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getVendorDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_VENDOR.GET_VENDOR_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue("business_name", data?.vendorDetail?.businessName);
        form.setFieldValue("store_name", data?.vendorDetail?.storeName);
        form.setFieldValue("first_name", data?.firstName);
        form.setFieldValue("last_name", data?.lastName);
        form.setFieldValue("email", data?.email);

        form.setFieldValue("address", data?.vendorDetail?.address);
        form.setFieldValue("business_category_id", data?.vendorDetail?.businessCategoryId);
        form.setFieldValue("registration_number", data?.vendorDetail?.commercialRegistrationNumber);
        form.setFieldValue("total_no_of_branches", data?.vendorDetail?.noOfBranches);

        let mobile = (data?.mobileNo).split("-");
        form.setFieldValue("mobile_no", mobile[1]);
        form.setFieldValue("vendor_type", data?.vendorDetail?.vendor_type);
        form.setFieldValue("vat", data?.vendorDetail?.vat);
        form.setFieldValue("quickbook_number", data?.vendorDetail?.quickbookNumber || "");
        form.setFieldValue("startDate", dayjs(data?.vendorDetail?.planStartDate));
        form.setFieldValue("endDate", dayjs(data?.vendorDetail?.planEndDate));
        form.setFieldValue("subscription_id", data?.subscription?.id);
        // form.setFieldValue("deduction", data?.vendorDetail?.deduction);
        const isWalletTopupEnabled = data?.vendorDetail?.settings?.walletToggle ? true : false;
        console.log("isWalletTopupEnabled222", isWalletTopupEnabled);
        if (isWalletTopupEnabled) {
            setWalletToggle(true);
        } else {
            setWalletToggle(false);
        }

        setPreviewImage(`https://rabbitholebucket.s3.eu-north-1.amazonaws.com/` + data?.vendorDetail?.businessImage);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllSubscriptions = async () => {
      dispatch(changeLoader(true));
      try {
        let response = await globalRequest(
          Apis.MANAGE_SUBSCRIPTION.GET_ALL_SUBSCRIPTIONS,
          "get",
          {},
          {},
          true
        );
        let apiResponse = response?.data;
        if (response?.status === 200) {
           const subs = response?.data?.data?.data;
           const activeSubs = subs.filter(sub => sub.subscriptionStatus === "active");
           console.log(activeSubs, "active subscriptions from API");
           setList(activeSubs);
          // setTotalRows(apiResponse?.data?.paginator?.itemCount);
        } else {
          toast.error(apiResponse?.message);
        }
      } catch (e) {
        toast.error(e?.message);
      }
      dispatch(changeLoader(false));
  };

  useEffect(() => {
    const loadData = async () => {
      dispatch(changeLoader(true));
      
      await getAllBusinessCategories();
      await getAllSubscriptions();
      if (id) {
        await getVendorDetail(id);
      } else {form.setFieldValue("total_no_of_branches", 1);
      }
      setIsDataLoaded(true);
      dispatch(changeLoader(false));
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Business Name"
            name="business_name"
            rules={[
              {
                required: true,
                message: "Please enter your Business Name.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("business_name", value.trimStart());
                handleInputChange("business_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Store Name"
            name="store_name"
            rules={[
              {
                required: true,
                message: "Please enter your Store Name.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("store_name", value.trimStart());
                handleInputChange("store_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Vendor First Name"
            name="first_name"
            rules={[
              {
                required: true,
                message: "Please enter your Vendor First Name.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("first_name", value.trimStart());
                handleInputChange("first_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Vendor Last Name"
            name="last_name"
            rules={[
              {
                required: true,
                message: "Please enter your Vendor Last Name.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("last_name", value.trimStart());
                handleInputChange("last_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              {
                required: true,
                message: "Please enter your Email Address.",
              },
              {
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={id ? true : false}
              size="large"
              onChange={(e) => {
                // let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("email", e.target.value.trimStart());
                handleInputChange("email");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Mobile no"
            name="mobile_no"
            rules={[
              {
                required: true,
                message: "Please enter your Vendor mobile number.",
              },
              {
                min: 9,
                message: "Mobile number must be 9 digits",
              },
              {
                max: 9,
                message: "Mobile number must be no more than 9 digits",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              addonBefore={<span>+966</span>}
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number");
                form.setFieldValue("mobile_no", value.trimStart());
                handleInputChange("mobile_no");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Business image"
            name="business_image"
            rules={[
              {
                required: id ? false : true,
                message: "Please Select your Business image.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <div className="mb-4 h-[102px]">
              <Upload
                listType="picture-card"
                fileList={fileList}
                beforeUpload={() => false}
                onChange={handleUpload}
                onRemove={handleRemove}
                showUploadList={{ showPreviewIcon: false }}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
            </div>
          </Form.Item>
          <Form.Item
            label="Business Category"
            name="business_category_id"
            rules={[
              {
                required: true,
                message: "Please select vendor Business Category.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Select
              size="large"
              placeholder="Select Business Category"
              options={allCategories}
              showSearch
              allowClear
              loading={!isDataLoaded}
              disabled={!isDataLoaded}
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                form.setFieldValue("business_category_id", value);
                handleInputChange("business_category_id");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Commercial Registration number"
            name="registration_number"
            rules={[
              {
                required: true,
                message: "Please enter your Commercial Registration number.",
              },
              {
                max: 100,
                message: "Maximum 100 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number");
                form.setFieldValue("registration_number", value.trimStart());
                handleInputChange("registration_number");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Total number of branches"
            name="total_no_of_branches"
            rules={[
              {
                required: true,
                type: "number",
                message: "Please enter your Total number of branches.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number|max:3")
                  ? Number(Validation.strFormat(e.target.value, "number|max:3"))
                  : "";
                form.setFieldValue("total_no_of_branches", value);
                handleInputChange("total_no_of_branches");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Vat Number"
            name="vat"
            rules={[
              {
                required: true,
                // type: "number",
                message: "Please enter your vat number.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Number(Validation.strFormat(e.target.value, "number|max:16"))
                  ? Number(Validation.strFormat(e.target.value, "number|max:16"))
                  : "";
                form.setFieldValue("vat", value);
                handleInputChange("vat");
              }}
            />
          </Form.Item>
          <Form.Item
            label="QuickBooks Number"
            name="quickbook_number"
            rules={[
              {
                required: true,
                message: "Please enter the QuickBooks number.",
              },
              {
                pattern: /^[0-9]+$/,
                message: "QuickBooks number must contain only digits.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                form.setFieldValue("quickbook_number", value);
                handleInputChange("quickbook_number");
              }}
            />
          </Form.Item>
          {/* <Form.Item
            label="Deduction"
            name="deduction"
            rules={[
              {
                type: "number",
                message: "Please enter your deduction.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number|max:3")
                  ? Number(Validation.strFormat(e.target.value, "number|max:3"))
                  : "";
                form.setFieldValue("deduction", value);
                handleInputChange("deduction");
              }}
            />
          </Form.Item> */}
          <Form.Item
            label="Vendor Type"
            name="vendor_type"
            rules={[
              {
                required: true,
                // type: "number",
                message: "Please select your vendor Type.",
              },
            ]}
          >
            <Select
              mode="single"
              size="large"
              placeholder="Select"
              options={vendor_Type}
              showSearch
              filterOption={(input, vendor_Type) => (vendor_Type?.label ?? "").toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
          <Form.Item
            label="Subscription ID"
            name="subscription_id"
            rules={[
              {
                required: true,
                message: "Please select vendor Subscription ID.",
              },
            ]}
          >
            <Select
              mode="single"
              size="large"
              placeholder="Select"
              options={
                list?.map(sub => ({
                  label: `${sub.subscriptionId}`,
                  value: sub.id,
                }))
              }
              // showSearch
              // filterOption={(input, subscription_id) => (subscription_id?.label ?? "").toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
          <div className="flex gap-10">
            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[{ required: true, message: "Start Date is required" }]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              label="End Date"
              name="endDate"
              rules={[{ required: true, message: "End Date is required" }]}
            >
              <DatePicker />
            </Form.Item>
          </div>
        </Form>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-vendor")}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </div>
      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleCrop}>
            Crop and Upload
          </Button>,
        ]}
      >
        <Cropper src={image} style={{ height: 400, width: "100%" }} aspectRatio={1} guides={false} ref={cropperRef} />
      </Modal>
    </>
  );
};
export default VendorPersonalDetails;
